// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import X from "@insite/mobius/Icons/X";
import { productSelectorStyles } from "@pace/Overrides/Components/ProductSelector";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productSelectorStyles.clearIcon = {
    size: 18,
    color: "common.ui8",
    css: css`
        position: absolute;
        right: 10px;
        top: 35px;
        cursor: pointer;
        z-index: 1;
        &:hover {
            color: ${color("text.link")};
        }
        &.autocomplete-clear-icon {
            right: 35px;
            ${xScreen("lte", "md")} {
                right: 55px;
            }
        }
    `,
};

productSelectorStyles.buttonGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        justify-content: flex-end;
    `,
};

productSelectorStyles.selectButton = {
    css: css`
        margin-top: 21px;
        margin-bottom: 15px;
        ${xScreen("lte", "sm")} {
            margin-top: 30px;
            margin-bottom: 0;
            width: 100%;
        }
    `,
};

productSelectorStyles.scannerStyles = {
    barcodeButton: {
        css: css`
            background-color: transparent;
            margin-top: 11px;
            padding: 0;
            right: 35px;
            z-index: 2;
        `,
    },
    mobileBarcodeModal: {
        cssOverrides: {
            modalContent: css`
                &&&& {
                    padding: 0;
                }
            `,
            modalBody: css`
                &&&& {
                    ${xScreen("lt", "xs")} {
                        max-width: none;
                        margin: 0;
                    }
                }
            `,
        }
    },
};

productSelectorStyles.addButtonWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        margin: 12px 0;
    `,
};

productSelectorStyles.scannedProductWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        gap: 12px;
    `,
};

productSelectorStyles.productDescriptionStyles = {
    productDetailLink: {
        typographyProps: {
            size: 12,
            lineHeight: "13px",
            weight: fontConfig.weight.bold,
            css: css`
                &&& {
                    color: ${color("common.black")};
                }
            `,
        },
    },
};

productSelectorStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 135px;
            height: 135px;
        `,
    },
};

productSelectorStyles.existingItemMessage = {
    css: css`
        margin: 12px 0 0;
    `,
};

productSelectorStyles.searchWrapper = {
    css: css`
        position: relative;
    `,
};

productSelectorStyles.clearSelectedProductIcon = {
    size: 18,
    src: X,
    color: "text.link",
    css: css`
        position: absolute;
        top: 39px;
        cursor: pointer;
        right: 10px;
        &:hover {
            color: ${color("common.ui8")};
        }
    `,
};

productSelectorStyles.qtyGridItem = {
    width: [3, 3, 2, 1, 1],
    css: css`
        position: relative;
    `,
};